import { render, staticRenderFns } from "./dxs.vue?vue&type=template&id=02b00880&scoped=true&"
import script from "./dxs.vue?vue&type=script&lang=js&"
export * from "./dxs.vue?vue&type=script&lang=js&"
import style0 from "./dxs.vue?vue&type=style&index=0&id=02b00880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b00880",
  null
  
)

export default component.exports